import React from 'react';

export const LumaSpin = ({ size = 65, className = '' }) => {
  return (
    <div 
      className={`relative aspect-square ${className}`}
      style={{ width: `${size}px` }}
    >
      <span 
        className="absolute rounded-[50px] animate-loaderAnim shadow-[inset_0_0_0_3px] shadow-primary" 
      />
      <span 
        className="absolute rounded-[50px] animate-loaderAnim animation-delay-half shadow-[inset_0_0_0_3px] shadow-secondary" 
      />
    </div>
  );
};

export default LumaSpin;
